<template>
  <section>
    <h3 class="text-h5 text-md-h4">
      Отправляйте документы из МИС МедЛок сразу в личный кабинет пациента МедТочка
    </h3>

    <div class="mt-6 mt-md-12">
      <v-sheet
        v-for="(item, index) in medcardItemAdditionItems"
        :key="index"
        class="d-flex overflow-hidden flex-column flex-md-row rounded-xl pt-8 pt-md-0 mt-4 mt-md-6"
        :color="$display.mdAndUp.value ? undefined : 'ui-kit-bg-secondary'"
      >
        <div class="d-flex px-6 px-md-0 mr-0 mr-md-6">
          <span class="list-number-marker text-primary">{{ index + 1 }}</span>
          <div
            class="ml-6 pt-0 pt-md-3"
            :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'text-landing-body-2 font-weight-bold'"
          >
            {{ item.title }}
          </div>
        </div>

        <v-img
          :src="`${item.src}.png`"
          :srcset="$display.mdAndUp.value ? undefined : `${item.src}.png 1x, ${item.src}_3x.png 3x`"
          :width="$display.mdAndUp.value ? 648 : undefined"
          :height="$display.smAndDown.value ? '50vw' : 178"
          :max-height="178"
          :alt="item.alt"
        />
      </v-sheet>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

const $display = useDisplay()

const medcardItemAdditionItems = computed(() => {
  const prefix = $display.mdAndUp.value ? '' : '_mobile'

  return [
    {
      title: 'Включите модуль «Электронная медкарта» в МИС МедЛок',
      src: `/images/features/clinic/mis_phone_confirmation${prefix}`,
      alt: 'Подтверждение телефона в МедЛок',
    },
    {
      title: 'Врач заполняет протокол в МИС МедЛок и отправляет его пациенту',
      src: `/images/features/clinic/mis_complete_protocol${prefix}`,
      alt: 'Добавление документа пациенту через МедЛок',
    },
    {
      title: 'Пациент получает документы в МедТочке',
      src: `/images/features/clinic/mt_patient_document${prefix}`,
      alt: 'Заключение в МедТочке',
    },
  ]
})
</script>
